const handleSubmit = async ({ shelf: { isRsb, palletOrStackType } }, { props }) => {
  const { updateShelf, onClose, shelf } = props
  await updateShelf({ ...shelf, isRsb, palletOrStackType: palletOrStackType || null })
  onClose()
}

export default handleSubmit
